import getFetcher from 'api/utils/getFetcher';
import { useMemo } from 'react';
import useSWR from 'swr';
import type { LegacyDevice } from 'types/legacyDashboard';

export interface DeviceResult {
  success: true;
  data: LegacyDevice;
}

export interface DeviceResultError {}

const useDevice = (deviceId?: DeviceId, orgId?: OrgId) => {
  const url = deviceId
    ? `${process.env.VITE_API_ROOT}/devices/${deviceId}?orgid=${orgId ?? ''}`
    : null;

  const { data, error, isLoading, isValidating, mutate } = useSWR<DeviceResult, DeviceResultError>(
    url,
    getFetcher
  );

  const device: Partial<LegacyDevice> = useMemo(() => data?.data ?? {}, [data]);

  return {
    device,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

export default useDevice;
